import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import ServiceBody from "../../ServiceComponents/ServiceBody";

import { FaGreaterThan } from "react-icons/fa6";

import ServiceSection from "../../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../../PageElements/HomePageElements/ConsultSection";
import HolisticMainSection from "../../PageElements/HolisticPageElement/HolisticMainSection";

export default function HolisticCare() {
    return (
        <>
            <ServiceHeader
                childClass="pathologyBGSection"
                breadcrumb={<>Services <FaGreaterThan size={15} /> Holistic Care</>}
                title="Holistic Care"
            />

            
            <HolisticMainSection/>
            {/* <ConsultSection /> */}
        </>
    )
}